<template>
    <div id="register">
        <patternlib-headline :headline="$t('register.headline')" heading-tag="h2" separator="none" />
        <personalData 
            style="margin-top: 64px;" 
            ref="personalData" 
            tabindex="2"
            @personalData:firstname = "(newValue) => {$refs.newPassword.firstname = newValue}"
            @personalData:lastname = "(newValue) => {$refs.newPassword.lastname = newValue}"
        />

        <legalTexts ref="legalText" style="margin-top: 16px;"/>

        <div :class="$gStyle('lh-grid')">
            <div 
                style="
                    height: 0px;
                    border-bottom-width: 1px;
                    border-bottom-color: var(--color-steel-300);
                    margin: 64px 0px;"
                :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
            ></div>
        </div>

        <div 
            id="password"
            ref="credentials"
            :class="$gStyle('lh-grid')"
        >
            <patternlib-headline 
                :headline="$t('myAccount.credentials')" 
                heading-tag="h3" 
                separator="none" 
                style="display: block;"
                :class="$gStyle('col-span-4 md:col-span-8 xl:col-span-10')"
            />
            <div style="width: 100%;" :class="$gStyle('col-span-4 md:col-span-4 xl:col-span-5')">
                <patternlib-textinput 
                    :label="$t('myAccount.eMailAddress')" 
                    :error-text="mailErrorText"
                    :status="mailStatus"
                    style="margin-top: var(--spacing-7);"
                    @lhChange="(ev) => {
                        eMail = ev.detail.value
                        $refs.newPassword.email = ev.detail.value
                    }"
                    tabindex="0"
                    ref="mail"
                />
                <newPassword ref="newPassword" tabindex="1" style="margin-top: 16px;"/>
            </div>

            <patternlib-button 
                :label="$t('register.register')"
                @click="register()"
                :loading="loading"
                style="margin-top: 24px;"
                :class="$gStyle('col-start-1 col-span-4 md:order-3 md:max-w-65')"
            />

            <passwordTip :class="$gStyle('col-span-4 md:col-span-4 xl:col-span-5')" style="margin-top: 32px;"/>
        </div>
    </div>
</template>

<script>
import newPassword from "../components/newPassword.vue"
import passwordTip from "../components/passwordTip.vue"
import personalData from "../components/personalData.vue"
import legalTexts from "../components/legalTexts/main.vue"
import { useServices } from "../services/useServices"

const SCROLL_INTO_VIEW_SETTINGS = {behavior: "smooth", inline: "center", block: "center"}

export default {
    data: () => ({
        eMail: "",
        mailStatus: "default",
        mailErrorText: "",
        loading: false
    }),

    components: {
        newPassword,
        passwordTip,
        personalData,
        legalTexts
    },

    methods: {
        checkReturnToUrl(services) {
            let fragmentParamsString = window.location.hash.split("?")[1]
            if (!fragmentParamsString) {return}
            let params = new URLSearchParams(fragmentParamsString)
            if (params.has("return") && params.has("loginSource") && JSON.parse(params.get("return"))) {
                let loginsourceUrl = new URL(params.get("loginSource"))
                let loginsourceParams = new URLSearchParams(loginsourceUrl.search)
                if (loginsourceParams.has("returnTo")) {
                    services.$registration.setReturnToUrl(loginsourceParams.get("returnTo"))
                }
            } 
        },

        register() {
            this.mailStatus = "default"
            this.mailErrorText = this.$t("register.invalidMail")
            let name
            let domain
            [name, domain] = this.eMail.split("@")
            if(!name || !domain || !domain.includes(".")) {
                this.mailStatus = "error"
                this.$refs.credentials.scrollIntoView(SCROLL_INTO_VIEW_SETTINGS)
                return 
            }
            
            let data = this.$refs.personalData.getData()
            if (data == null) {
                this.$refs.personalData.$el.scrollIntoView(SCROLL_INTO_VIEW_SETTINGS)
                return 
            }
            let password = this.$refs.newPassword.getPassword(
                data.firstname,
                data.lastname,
                this.eMail
            )
            if (password == null) {
                this.$refs.newPassword.$el.scrollIntoView(SCROLL_INTO_VIEW_SETTINGS)
                return 
            }

            data = {
                email: this.eMail,
                password: password,
                returnUrl: (window.location.origin + window.location.pathname),
                ...data
            }
            
            if(!this.$refs.legalText.accept()) {return}
            

            this.loading=true
            const services = useServices()
            services.$api.registerUser((res) => {
                this.loading = false
                if (res.data == null) {
                    if (res.message == "UserAlreadyExists") {
                        this.mailErrorText = this.$t("register.mailAlreadyExists")
                        this.mailStatus = "error"
                        this.$refs.credentials.scrollIntoView(SCROLL_INTO_VIEW_SETTINGS)
                        return
                    }
                    this.$emit("showMessage", {
                        type: "alert",
                        showIcon: true,
                        message: this.$t("unknownError")
                    })
                    return
                }
                services.$registration.setSessionId(res.data)
                this.checkReturnToUrl(services)
                this.$router.push("/confirmMail")
            }, data)
        }
    },

    created() {
        const services = useServices()
        if (services.$registration.waitingForConformation()) {
            this.checkReturnToUrl(services)
            this.$router.push("/confirmMail")
        }
    },
    
    mounted() {
        this.$refs.personalData.displayOnly = false
    }
}
</script>

<style lang="scss" scoped>
#register {
    margin: 96px;
}

@media only screen and (max-width: 992px) {
    #register {
        margin: 48px;
    }
}

@media only screen and (max-width: 992px) {
    #register {
        margin: 24px;
    }
}

</style>